import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from '../partials/Link';

import styles from '../../../styles/buttons/link-button.module.scss';

const propTypes = {
    href: PropTypes.string,
    external: PropTypes.bool,
    children: PropTypes.node,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    innerClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    href: null,
    external: null,
    children: null,
    color: 'currentColor',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    innerClassName: null,
    className: null,
};

const LinkButton = ({
    href,
    external,
    children,
    color,
    backgroundColor,
    className,
    innerClassName,
}) => {
    const classes = classNames([
        styles.container,
        {
            [styles.empty]: children === null,
            [className]: className !== null,
        },
    ]);

    const inner = (
        <span
            className={classNames([
                styles.buttonInner,
                {
                    [innerClassName]: innerClassName !== null,
                },
            ])}
            style={{ backgroundColor: children !== null ? backgroundColor : null }}
        >
            {children}
            <span>→</span>
        </span>
    );

    return href !== null ? (
        <Link href={href} className={classes} external={external} style={{ color }}>
            {inner}
        </Link>
    ) : (
        <div className={classes} external={external} style={{ color }}>
            {inner}
        </div>
    );
};

LinkButton.propTypes = propTypes;
LinkButton.defaultProps = defaultProps;

export default LinkButton;
